import { FBInputType, OmitIncludeNotes } from '..';
import { DOC_TYPE_GROUP_OPTION, DocumentGroupOptionsType } from '../../../state/ducks/documentRevisions/documentType/types';

export const FBEditorPropertiesDefaultValue = (type: FBInputType, docGroupOptions?: DocumentGroupOptionsType[]) => {
  if (docGroupOptions?.includes(DOC_TYPE_GROUP_OPTION.FB_DEFAULT_NOTES)) {
    if (!OmitIncludeNotes.includes(type)) {
      return {
        procedure: ['copyableValue', 'includeNotes'],
        eqmaintenance: ['deleteDisabled', 'includeNotes'],
        [type]: ['includeNotes'],
      };
    }
  }
  return {
    procedure: ['copyableValue'],
  };
};
